import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageSquare, FileText, Shield } from 'lucide-react';
import { APP_VERSION, BUILD_DATE } from '../config';

export default function Footer() {
  return (
    <footer className="w-full border-t border-white/10 bg-black/30 backdrop-blur-sm mt-auto">
      <div className="container-wide py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Support Email */}
          <div className="flex items-center gap-2 text-zinc-400">
            <Mail className="h-4 w-4" />
            <a 
              href="mailto:support@wrappedinmusic.com" 
              className="hover:text-primary transition-colors"
              data-testid="footer-email"
            >
              support@wrappedinmusic.com
            </a>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/feedback" 
              className="flex items-center gap-2 text-zinc-400 hover:text-primary transition-colors"
              data-testid="footer-feedback-link"
            >
              <MessageSquare className="h-4 w-4" />
              Feedback
            </Link>
            <Link 
              to="/terms" 
              className="flex items-center gap-2 text-zinc-400 hover:text-primary transition-colors"
              data-testid="footer-terms-link"
            >
              <FileText className="h-4 w-4" />
              Terms
            </Link>
            <Link 
              to="/privacy" 
              className="flex items-center gap-2 text-zinc-400 hover:text-primary transition-colors"
              data-testid="footer-privacy-link"
            >
              <Shield className="h-4 w-4" />
              Privacy
            </Link>
          </div>

          {/* Copyright & Version */}
          <div className="text-zinc-500 text-sm text-center">
            <div>&copy; {new Date().getFullYear()} Wrapped In Music</div>
            <div className="text-xs text-zinc-600">{APP_VERSION} • {BUILD_DATE}</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
